import * as THREE from "three";
import Orchestrator from "./Orchestrator.js";

export default class Camera {
    constructor() {
        this.orc = new Orchestrator();
        this.sizes = this.orc.sizes;
        this.scene = this.orc.scene;
        this.canvas = this.orc.canvas;

        this.target = new THREE.Vector3(0, 0, 0);
        this.spherical = new THREE.Spherical(5, Math.PI * 0.5, 0);
        this.targetSpherical = this.spherical.clone();

        // Max orbit offset from the resting view (radians)
        this.maxAzimuth = 0.2;
        this.maxPolarOffset = 0.1;
        // Higher = snappier follow
        this.easing = 4;

        this.cursor = { x: 0, y: 0 };

        this.setInstance();
        this.setCursorTracking();
        this.applySpherical();
    }

    setInstance() {
        this.instance = new THREE.PerspectiveCamera(
            40,
            this.sizes.width / this.sizes.height,
            0.1,
            1000,
        );
        this.scene.add(this.instance);
    }

    setCursorTracking() {
        this.onPointerMove = (event) => {
            this.cursor.x = (event.clientX / this.sizes.width) * 2 - 1;
            this.cursor.y = (event.clientY / this.sizes.height) * 2 - 1;
        };

        this.onPointerLeave = () => {
            this.cursor.x = 0;
            this.cursor.y = 0;
        };

        window.addEventListener("pointermove", this.onPointerMove);
        document.body.addEventListener("pointerleave", this.onPointerLeave);
    }

    applySpherical() {
        this.instance.position.setFromSpherical(this.spherical);
        this.instance.position.add(this.target);
        this.instance.lookAt(this.target);
    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height;
        this.instance.updateProjectionMatrix();
    }

    update(_elapsed, delta = 1 / 60) {
        this.targetSpherical.theta = -this.cursor.x * this.maxAzimuth;
        this.targetSpherical.phi =
            Math.PI * 0.5 + this.cursor.y * this.maxPolarOffset;

        const t = 1 - Math.exp(-this.easing * delta);
        this.spherical.theta +=
            (this.targetSpherical.theta - this.spherical.theta) * t;
        this.spherical.phi +=
            (this.targetSpherical.phi - this.spherical.phi) * t;

        this.applySpherical();
    }

    destroy() {
        window.removeEventListener("pointermove", this.onPointerMove);
        document.body.removeEventListener("pointerleave", this.onPointerLeave);
    }
}
